import { getOwnProperty } from '../../utils/getOwnProperty';
export const extractPropertyValues = (updates, condition) => {
  if (!updates) {
    return {};
  }
  const result = {};
  for (const name of Object.keys(updates)) {
    const updateValue = getOwnProperty(updates, name);
    if (updateValue !== undefined) {
      if (!condition || condition(updateValue)) {
        result[name] = updateValue === null || updateValue === void 0 ? void 0 : updateValue.value;
      }
    }
  }
  return result;
};
export const extractPropertyValuesFromObjectMap = updates => {
  if (!updates) {
    return {};
  }
  const result = {};
  for (const objectId of Object.keys(updates)) {
    const properties = updates[objectId];
    if (properties !== undefined) {
      result[objectId] = extractPropertyValues(properties);
    }
  }
  return result;
};